import React from 'react';

/** Shared /design gallery section frame (rail label + bordered card). */
const Section: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <section className="flex flex-col gap-s4">
    <h2 className="text-rail-label uppercase text-ink-muted">{title}</h2>
    <div className="rounded-card border border-line bg-surface p-s6">{children}</div>
  </section>
);

export default Section;
